import React from 'react';

const CancelarPrestamoModal = ({
  show,
  onClose,
  selectedPrestamo,
  cancelarForm,
  errors,
  handleInputChange,
  handleConfirmAction
}) => {
  if (!show) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-panel modal-panel-sm p-6">
        <h3 className="modal-title mb-4">
          Cancelar Préstamo #{selectedPrestamo.idPrestamo}
        </h3>

        <div className="mb-4">
          <p className="modal-text mb-1">
            Préstamo: #{selectedPrestamo.idPrestamo} - {selectedPrestamo.modalidad}
          </p>
          <p className="modal-text mb-1">
            Monto pendiente total: S/ {parseFloat(cancelarForm.monto_pagado).toFixed(2)}
          </p>
        </div>

        <div className="mb-4">
          <label className="modal-label">
            Monto a pagar
          </label>
          <input
            type="number"
            name="monto_pagado"
            value={cancelarForm.monto_pagado}
            className={`modal-input cursor-not-allowed ${errors.monto_pagado ? 'border-red-500' : ''}`}
            step="0.01"
            min={parseFloat(cancelarForm.monto_pagado).toFixed(2)}
            max="999999"
            readOnly
          />
          {errors.monto_pagado && (
            <p className="text-red-500 text-xs mt-1">{errors.monto_pagado}</p>
          )}
        </div>

        <div className="mb-4">
          <label className="modal-label">
            Número de Operación
          </label>
          <input
            type="text"
            name="numero_operacion"
            value={cancelarForm.numero_operacion}
            onChange={handleInputChange}
            className="modal-input"
            maxLength="50"
          />
        </div>

        <div className="mb-4">
          <label className="modal-label">
            Observaciones (opcional)
          </label>
          <textarea
            name="observaciones"
            value={cancelarForm.observaciones}
            onChange={handleInputChange}
            className="modal-textarea"
            rows="2"
            maxLength="255"
          ></textarea>
        </div>

        <div className="modal-actions">
          <button
            onClick={onClose}
            className="btn-modal-neutral"
          >
            Cancelar
          </button>
          <button
            onClick={handleConfirmAction}
            className="btn-modal-warning"
          >
            Cancelar Préstamo
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelarPrestamoModal;
